import {useState} from 'react';
import {
  StyledModal,
  ModalHeader,
  ModalContent,
  ModalActions,
  CloseButton,
  CloseIcon,
} from './StandardModal.styles';
import ModalTitle from '../../Typography/ModalTitle/ModalTitle';
import LinkButton from '../../Buttons/LinkButton/LinkButton';
import OutlinedButton from '../../Buttons/OutlinedButton/OutlinedButton';
import SectionSpinner from '../../Loading/SectionSpinner/SectionSpinner';

const StandardModal = ({children, open, onClose, title, btnText, onClick, disabled, loading, hideCancelBtn, width}) => {
  const [show, setShow] = useState(open);

  const handleClose = () => {
    setShow(false);
    onClose();
  };

  return (
    <>
      <StyledModal
        open={show}
        scroll={'body'}
        width={width}
      >
        <ModalHeader>
          <ModalTitle
            text={title}
          />
          <CloseButton
            aria-label='close'
            onClick={handleClose}
          >
            <CloseIcon/>
          </CloseButton>
        </ModalHeader>
        <ModalContent>
          {children}
        </ModalContent>
        <ModalActions>
          {
            loading &&
            <SectionSpinner/>
          }
          {
            !loading &&
            <>
              {
                !hideCancelBtn &&
                <LinkButton
                  text={'Cancel'}
                  onClick={handleClose}
                  isReset
                />
              }
              <OutlinedButton
                text={btnText}
                onClick={hideCancelBtn ? handleClose : onClick}
                disabled={disabled}
              />
            </>
          }
        </ModalActions>
      </StyledModal>
    </>
  );
};

export default StandardModal;
